export const citizenLightNew = {
  name: 'citizen2:light',
  extends: 'onify:helix',
  cssPath: 'custom/styles/citizen-light.theme',
  vuetify: {
    defaults: {
      HBulletin: {
        HActionLink: {
          HScopedBulletinActionBtn: {
            size: 'default',
            rounded: 'pill',
            flat: true,
            icon: false,
            appendIcon: 'mdi:mdi-chevron-right',
            variant: 'text',
          },
        },
        VCard: {
          color: null,
        },
      },
      HWorkspace: {
        HBulletin: {
          VCard: {
            color: null,
          },
          HActionLink: {
            HScopedBulletinActionBtn: {
              size: 'default',
              rounded: 'pill',
              flat: true,
              icon: false,
              appendIcon: 'mdi:mdi-chevron-right',
              variant: 'text',
            },
          },
        },
        HShortcut: {
          VAvatar: {
            color: 'background',
          },
        },
      },

      VCard: {
        color: 'surface-gradient',
        rounded: 'xl',
      },

      HItemCard: {
        VCard: {
          color: 'surface-gradient',
          rounded: 'xl',
        },
        HScopedItemCardActionBtn: {
          color: 'secondary',
          variant: 'flat',
          rounded: 'pill',
        },
        HScopedItemCardMenuBtn: {
          variant: 'flat',
          appendIcon: 'mdi:mdi-menu-down',
          color: 'primary',
          rounded: 'pill',
        },
      },

      VBtn: {
        variant: 'outlined',
        rounded: 'xl',
      },

      HShortcut: {
        VBadge: {
          color: 'badge-primary',
          inline: true,
        },
      },

      HDialog: {
        VCard: {
          color: null,
        },
      },
    },
    theme: {
      dark: false,
      colors: {
        primary: '#006160',
        'primary-lighten-4': '#CCDFDF',
        'on-primary': '#FAFAFA',
        secondary: '#FFD451',
        'on-secondary': '#404040',
        'search-list-hover': '#9DD5D6',
        tertiary: '#FFD0C9',
        accent: '#3B82F6',
        error: '#99092D',
        success: '#008568',
        warning: '#D16F00',
        'warning-lighten-1': '#D16F00',
        'warning-lighten-3': '#FFDDB5',
        surface: '#CCDFDF',
        'on-surface': '#404040',
        'surface-variant': '#FFECE9',
        'on-surface-variant': '#404040',
        background: '#FAFAFA',
        'on-background': '#404040',
        neutral: '#9DD5D6',
        'on-neutral-100': '#404040',
        'breadcrumb-hover': '#CED1D2',
        'on-breadcrumb': '#404040',
        bulletin: '#CCDFDF',
        'bulletin-2': '#DDEBEBFC',
        'on-bulletin': '#404040',
        'bulletin-informational': '#CCDFDF',
        'on-bulletin-informational': '#404040',
        'bulletin-warning': '#FFDDB5',
        'on-bulletin-warning': '#404040',
        'bulletin-critical': '#FFB3BA',
        'on-bulletin-critical': '#404040',
        'bulletin-success': '#B8E6D5',
        'on-bulletin-success': '#404040',
        'bulletin-board': '#006160',
        'bulletin-board-2': '#CCDFDF',
        'on-bulletin-board': '#FAFAFA',
        'start-page': '#CED1D2',
        'on-start-page': '#FAFAFA',
        'badge-primary': '#FFD451',
        'on-badge-primary': '#404040',
        'badge-tertiary': '#FFD451',
        'on-badge-tertiary': '#404040',
        toolbar: '#006160',
        'on-toolbar': '#FAFAFA',
        'surface-gradient': '#CCDFDF',
        'on-surface-gradient': '#404040',
        'surface-gradient-2': '#DDEBEBFC',
        loader: '#006160',
        'loader-background': '#E0E3E1',

        // Custom:
        fullmakter: '#FFECE9',
        'on-fullmakter': '#404040',
        foretag: '#FFECE9',
        'on-foretag': '#404040',
        fastigheter: '#FFECE9',
        'on-fastigheter': '#404040',
        'bulletin-informational-button': '#FFD451',
        'bulletin-informational-button-hover': '#2A6960',
        adshavare: '#FFECE9',
        'on-adshavare': '#404040',

        // My cases page colors
        'my-cases': '#FFECE9',
        'on-my-cases': '#404040',
        'my-cases-action': '#006160',
        'on-my-cases-action': '#FAFAFA',
        'header-button': '#006160',
        'on-header-button': '#FAFAFA',

        // Chip colors for filter buttons and status chips
        'chip-active': '#D4736A',
        'on-chip-active': '#FAFAFA',
        'chip-inactive': '#E0E3E1',
        'on-chip-inactive': '#404040',

        // Additional colors from karlskrona theme (adapted for citizen palette)
        'neutral-100': '#FAFAFA',
        'primary-lighten-1': '#338F8E',
        'primary-lighten-2': '#66AFAE',
        'primary-lighten-3': '#9DD5D6',
        'secondary-lighten-1': '#FFE080',
        'secondary-lighten-2': '#FFEBAA',
        'secondary-lighten-3': '#FFF5D5',
        'error-lighten-1': '#B34D5E',
        'error-lighten-2': '#D9909A',
        'error-lighten-3': '#F5D5D8',
        'on-error-lighten-2': '#404040',
        'success-lighten-1': '#33A088',
        'success-lighten-2': '#66B8A8',
        'success-lighten-3': '#B8E6D5',
        'warning-lighten-2': '#F0B870',
        'background-3': '#E8F4F4',
        'on-background-3': '#404040',
        'background-4': '#9DD5D6',
        'on-background-4': '#404040',
        black: '#001A1B',
        'black-lighten-1': '#333333',
        gray: '#605d62',
        'gray-lighten-1': '#79767a',
        'gray-lighten-2': '#F4F3F2',
        white: '#FFFFFF',
        'white-darken-1': '#E8F0F0',
        red: '#99092D',
        'badge-disabled': '#A5A5A5',
        'badge-secondary': '#9DD5D6',
        green: '#006160',
        disabled: '#A5A5A5',
        'text-color-primary': '#1A1C1E',
        'text-color-secondary': '#41474D',
        ovriga: '#9DD5D6',
        'on-ovriga': '#404040',
        utbildning: '#9DD5D6',
        'on-utbildning': '#404040',
        omsorg: '#FFD451',
        'on-omsorg': '#404040',
        forening: '#CCDFDF',
        'on-forening': '#404040',
        anstallningar: '#9DD5D6',
        'on-anstallningar': '#404040',
        'sector-privat': '#CCDFDF',
        'sector-företag': '#FFECE9',
        'on-sector-privat': '#404040',
        'on-sector-företag': '#404040',
        scrollbar: '#006160',
        'my-eservices': '#FFECE9',
        'on-my-eservices': '#404040',
        'arbete-naringsliv': '#FFECE9',
        'on-arbete-naringsliv': '#404040',
        'boende-miljo': '#CCDFDF',
        'on-boende-miljo': '#404040',
        'kommun-politik': '#006160',
        'on-kommun-politik': '#FAFAFA',
        'omsorg-stod': '#FFD451',
        'on-omsorg-stod': '#404040',
        ovrigt: '#9DD5D6',
        'on-ovrigt': '#404040',
        'forskola-skola': '#9DD5D6',
        'on-forskola-skola': '#404040',
        'kultur-fritid-turism': '#CCDFDF',
        'on-kultur-fritid-turism': '#404040',
        raddningstjansten: '#FFECE9',
        'on-raddningstjansten': '#404040',

        // Page header background colors
        'page-companies-header-bg': '#FFECE9',
        'on-page-companies-header-bg': '#404040',
        'page-properties-header-bg': '#FFECE9',
        'on-page-properties-header-bg': '#404040',
        'page-authorizations-header-bg': '#FFECE9',
        'on-page-authorizations-header-bg': '#404040',
        'page-children-header-bg': '#FFECE9',
        'on-page-children-header-bg': '#404040',
        'page-enrollments-header-bg': '#FFECE9',
        'on-page-enrollments-header-bg': '#404040',
        'page-employments-header-bg': '#FFECE9',
        'on-page-employments-header-bg': '#404040',
        'page-eservices-header-bg': '#FFECE9',
        'on-page-eservices-header-bg': '#404040',
        'page-cases-header-bg': '#FFECE9',
        'on-page-cases-header-bg': '#404040',

        // Item card border colors
        'card-assignment': '#FFECE9',
        'on-card-assignment': '#404040',
        'card-company': '#FFECE9',
        'card-property': '#FFECE9',
        'card-authorization': '#FFECE9',
        'card-child': '#FFECE9',
        'card-enrollment': '#FFECE9',
        'card-employment': '#FFECE9',
        'card-case': '#FFECE9',
        'card-association': '#A5A5A5',

        get 'process-state-active'() {
          return this.accent;
        },

        get 'on-process-state-active'() {
          return this.surface;
        },

        get 'process-state-inactive'() {
          return this['on-surface'];
        },

        get 'on-process-state-inactive'() {
          return this.surface;
        },

        get 'process-state-skipped'() {
          return this.disabled;
        },

        get 'on-process-state-skipped'() {
          return this.surface;
        },

        get 'process-state-done'() {
          return this.success;
        },

        get 'on-process-state-done'() {
          return this.surface;
        },

        get 'process-state-error'() {
          return this.error;
        },

        get 'on-process-state-error'() {
          return this.surface;
        },
      },
    },
  },
};
